<template>
  <div>
    <people-nav
    @updatedSearchTerm="handleSearch"
    @backToMainPeoplePage="handleBack"
    :viewing-profile="viewingProfile"
    ></people-nav>
    <person-selector
      v-if="viewingProfile"
      :people="filteredPeople"
      @selectPerson="selectPerson"
      ></person-selector>
    <div class="person-content">
      <div v-if="viewingProfile" class="person-display">
        <person-page></person-page>
      </div>
      <div v-if="!viewingProfile">
        <people-filters @changeFilter="handleChangeFilter" @showInactive="handleShowInactive"></people-filters>
        <div class="people-cards">
          <div class="person-card"
            v-for="p in filteredPeople" 
            :key="p.fName + p.lName"
            @click="selectPerson(p)"
          >
            <v-card color="white">
              <div class="person-image-holder">
                <img
                  src="https://cdn.vuetifyjs.com/images/cards/road.jpg"
                  class="person-image"
                >
              </div>
              <div class="person-card-content person-name">{{p.fName + " " + p.lName}}</div>
              <div class="person-card-content person-job">{{p.group}}</div>
            </v-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setSelected, getPersonsPushId } from "@/vue-service-selected_person";
import PeopleNavigation from "./PeopleNavigation.vue";
import PeopleFilters from "./PeopleFilters.vue";
import PersonPage from "./PersonPage.vue";
import PersonSelector from "./PersonSelector.vue";

export default {
  components: {
    "people-nav": PeopleNavigation,
    "people-filters": PeopleFilters,
    "person-page": PersonPage,
    "person-selector": PersonSelector,
  },
  data() {
    return {
      search: "",
      showInactive: false,
      viewingProfile: false,
      filters: {},
    };
  },
  computed: {
    filteredPeople() {
      let filtered = [];

      // Get the correct search set
      for(let key in this.$store.getters.people){
        let person = this.$store.getters.people[key];

      // If the search contains the person's name or email, keep them
      if(this.search ? (
          person.fName.toLowerCase().includes(this.search.toLowerCase()) ||
          person.lName.toLowerCase().includes(this.search.toLowerCase()) ||
          (person.fName + person.lName).toLowerCase().includes(this.search.toLowerCase()) ||
          person.email.toLowerCase().includes(this.search.toLowerCase())
        ) : true){
          // If the person is active or inactive people are being shown (in addition to new ones)
          // Perhaps this should be xor
          if(person.active || this.showInactive){
            filtered.push(person);
          }
        }
      }

      // Apply filters
      filtered = filtered.filter(person => {
        for(let key in this.filters){
          // For each of the filters
          let filter = this.filters[key];
          // If there is anything in the filter
          if(filter !== []){
            // If person does not have the key, they cannot possibly match the filter
            if(person[key] === undefined) return false;

            // Assume the person does not fall into the category
            let withinFilter = false;
            for(let item of filter){
              // If they do match an item in the filter, say so
              if(item.toLowerCase() === person[key].toLowerCase()){
                withinFilter = true;
              }
            }

            // If they made it through the filter without matching anything, exclude them
            if(!withinFilter){
              return false;
            }
          }
        }
        //If they matched all filters or there were no filters, return true
        return true;
      });

      // Return the people sorted by full name
      return filtered.sort((personA, personB) => {
        let a = (personA.fName + " " + personA.lName);
        let b = (personB.fName + " " + personB.lName);
        return a < b ? -1 : (b < a ? 1 : 0);
      });
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleSearch(searchTerm){
      this.search = searchTerm;
    },
    handleChangeFilter(id, value){
      // If the clear all button sent this signal, clear all filters
      if(id === "clearAll"){
        this.filters = {};
      } else {
        // Otherwise, apply the filters to a new object to trigger an update
        let newObj = {};
        newObj[id] = value;
        this.filters = Object.assign({}, this.filters, newObj);
      }
    },
    handleShowInactive(value){
      this.showInactive = value;
    },
    selectPerson(person){
      this.viewingProfile = true;
      const key = getPersonsPushId(person.email);
      setSelected(key);
    },
    handleBack(){
      this.viewingProfile = false
    },
  }
};
</script>

<style scoped>
.icon-space {
  margin-right: 10px;
  margin-bottom: 0px;
  padding-right: 10px;
  padding-bottom: 0px;
}
.people-cards{
  display: flex;
  flex-wrap: wrap;
}
.person-card{
  width: 13.2%;
  margin-right: 1.166%;
  margin-bottom: 20px;
  cursor: pointer;
}
.person-card:nth-child(7n){
  margin-right: 0px;
}
.person-image-holder{
  padding: 10%;
  width: 100%;
}
.person-image{
  width: 100%;
  border-radius: 50%;
}
.person-card-content{
  width: 100%;
  text-align: center;
}
.person-name{
  font-weight: bold;
}
.person-job{
  font-weight: 300;
  color: rgba(0, 0, 0, 0.6);
  padding-bottom: 10px;
}
.person-display{
  margin: -20px -25px 0px 55px;
  height: 100%;
}
.person-content{
  padding-top: 80px;
}
</style>




// WEBPACK FOOTER //
// src/components/People/People.vue